import { NODE_TYPES } from '@/entities/user';
import { useAuth } from '@/features/authentication';
import { Footer } from '@/widgets/footer';
import { Navbar } from '@/widgets/navbar';
import { Heart, Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

/// Layout for the protected dashboard route group. Redirects unauthenticated
/// users to /login. (React Router port of the Next.js (dashboard)/layout.tsx.)
export function DashboardLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();
  // Signup not finished (phone/photo missing): the API refuses member routes
  // (403 registration_incomplete), send them back to the signup wizard.
  const isPendingRegistration = user?.nodeTypeId === NODE_TYPES.PENDING_VALIDATION;

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      navigate('/login');
    } else if (isPendingRegistration) {
      navigate('/register', { replace: true });
    }
  }, [isAuthenticated, isLoading, isPendingRegistration, navigate]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background pattern-geometric">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center shadow-[var(--shadow-primary)]">
            <Heart className="h-6 w-6 text-primary-foreground" />
          </div>
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated || isPendingRegistration) {
    return null;
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
